import { render, staticRenderFns } from "./flexbotton.vue?vue&type=template&id=68175c94&scoped=true&"
import script from "./flexbotton.vue?vue&type=script&lang=js&"
export * from "./flexbotton.vue?vue&type=script&lang=js&"
import style0 from "./flexbotton.vue?vue&type=style&index=0&id=68175c94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68175c94",
  null
  
)

export default component.exports